import i18n from 'i18next'
export default () => {
  const t = i18n.t.bind(i18n)
  const filters = document.querySelectorAll('div.rt-th > input')
  for (const filter of filters) {
    filter.placeholder = `${t('Search')}...`
  }
}
